import React, { useEffect, useState } from 'react'
import { LeasesBasicDetails, LeasesMenuList, LeasesNav } from '../../elements';
import { Box, Button, Grid, MenuItem, Paper } from '@mui/material';
import FilterListIcon from '@mui/icons-material/FilterList';
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
import ArrowCircleRightOutlinedIcon from '@mui/icons-material/ArrowCircleRightOutlined';
import { FilterComponent, PageLoader, PopOverCTA, STableLoader } from '../../../shared_elements';
import { globalGetService } from '../../../utils/globalApiServices';
import { checkApiStatus } from '../../../utils';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import CashFlowListing from '../components/CashFlowListing';
import CashflowDetailsModal from '../components/CashflowDetailsModal';
import { isMobile } from 'react-device-detect';
import { RoleBaseAccess } from '../../../hoc';
import { trackActivity } from '../../../utils/mixpanel';
import ModuleNotExcessModal from '../../../shared_elements/components/ModuleNotExcessModal';
import { getCurrencyAc, getLesseeAc, getLessorAc } from '../../../shared_elements/actionCreators';
import { getAssetListApi } from '../../leases/apiServices';
import { getCashflowCategoriesApi, getTransactionTypesApi } from '../../settings/cashflow_categories/apiService';
import BackToLeaseList from '../../elements/BackToLeaseList';
import { exportCashFlowApi } from '../apiService';
import ExportFileTypeComp from '../../../shared_elements/components/ExportFileTypeComp';
import { enqueueSnackbar } from 'notistack';
import moment from 'moment';

const Cashflow = () => {
	const dispatch = useDispatch();
	const [isLoading, setLoading] = useState(false)
	const { leaseBasicDetails } = useSelector((state) => state.leases);
	const [cashflowDetailsModal, setCashflowDetailsModal] = useState({
		open: false,
		start_date: null,
		end_date: null,
		mode: "monthly",
	});
	const [cashFlowListing, setCashFlowListing] = useState({})
	const [mode, setMode] = useState("monthly");
	const [currency, setcurrency] = useState("USD");
	const { lessee, lessor, currencies } = useSelector((state) => state.leases);
	const [year, setYear] = useState(new Date().getFullYear());
	const { leaseSlug } = useParams();
	const [isExport, setExport] = useState(false)
	const [skeletonLoader, setSkeletonLoader] = useState(false);
	const [filter, setFilter] = useState({});
	const [assetList, setAssetList] = useState([]);
	const [transactionTypes, setTransactionTypes] = useState([]);
	const [section, setSection] = useState([]);
	const statusLabel = [{ id: "draft", Label: "Draft" }, { id: "active", Label: "Active" }, { id: "closed", Label: "Closed" }, { id: "terminated", Label: "Terminated" }, { id: "on-hold", Label: "On-hold" }]
	const invoiceTypeOptions = [ { label: 'Maintenance Reserve', value: 1 }, { label: 'Rental', value: 2 }, { label: 'Penalty', value: 3 }, { label: 'Debit', value: 4 }, { label: 'Credit', value: 5 }, { label: 'Adhoc', value: 9 }, ];
	const showOnlyOption = [{value:'all',label:'All Section'},{value:'outflows',label:'Outflows Only'},{value:'inflows',label:'Inflows Only'}]
	const currencyOptions = currencies?.length > 0 ? currencies : [ { id: 27, code: 'GBP' }, { id: 3,  code: 'EURO' }, { id: 1,  code: 'USD' }, ];
	const currencyLabel = currency || "USD";
	const currencySymbol = currencyOptions.find( (cur) => String(cur.code) === String(currency) )?.symbol || "$";
	useEffect(() => {
		trackActivity('Page Viewed',{ page_title: 'CashFlow'})
	}, [])

	useEffect(() => {
		if (!leaseBasicDetails) return;
		if (leaseBasicDetails?.status === "Draft") return;
		getCashFlowList('skeletonLoader', mode, year, currency)

		if (!lessee?.length) {
          dispatch(getLesseeAc({}));
        }

        if (!lessor?.length) {
          dispatch(getLessorAc({}));
        }

		if (!currencies?.length) {
          dispatch(getCurrencyAc({}));
        }

		getAssetList();
		getTransactionTypes();
		getSections();
	}, [leaseBasicDetails?.status, mode, year, currency])

	const getCashFlowList = (loaderType, selectedMode, selectedYear, selectedCurrency, query={}) => {
		const queryString = new URLSearchParams(query).toString();
		const hasDateRange = query?.start_date && query?.end_date;
		loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
        const url = `/cashflows?${hasDateRange ? '' : `year=${selectedYear}&`}lease_slug=${leaseSlug}&mode=${selectedMode}&currency=${selectedCurrency}${queryString ? '&' + queryString : ''}`;
		globalGetService(url)
			.then(response => {
				if (checkApiStatus) {
					setCashFlowListing(response?.data)
					setFilter(query);
					loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
					if(response.data.statusCode === 400){
						enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } });
					}
				}
				loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
			})
	}
	const getAssetList = () => {
		globalGetService(getAssetListApi({})).then(response => {
			if (checkApiStatus) {
				setAssetList(response?.data?.data)
			}
		})
	}

	const getTransactionTypes = (query) => {
		globalGetService(getTransactionTypesApi(query))
			.then(response => {
				if (checkApiStatus(response)) {
					setTransactionTypes(response?.data?.data?.list);
				}
			})
	}

	const getSections = (query) => {
		globalGetService(getCashflowCategoriesApi(query))
			.then(response => {
				if (checkApiStatus(response)) {
					setSection(response?.data?.data?.list);
				}
			})
	}

	const handleModeChange = (newMode) => {
		setMode(newMode.toLowerCase())
	}

    const handleCurrencyChange = (newMode) => {
		setcurrency(newMode)
	}

	const handleYearChange = (direction) => {
		setYear(prev => direction === 'prev' ? prev - 1 : prev + 1)
	}

	const today = new Date()
	const endDate = leaseBasicDetails?.end_date ? new Date(leaseBasicDetails.end_date) : null

	const maxAllowedYear = endDate ? endDate.getFullYear() : today.getFullYear();

	const minAllowedYear = leaseBasicDetails?.start_date
		? new Date(leaseBasicDetails.start_date).getFullYear()
		: 1900 

	const canGoPrev = year > minAllowedYear
	const canGoNext = year < maxAllowedYear

	const handleItemClicked = (page_type) => {
			trackActivity('Item Clicked', { page_title: 'CashFlow', page_type: page_type, })
		}
    const cashflowFilterMenu = {
		start_date: { title: 'From Date', inputType: 'date' },
        end_date: { title: 'To Date', inputType: 'date' },
		// lessor_ids: { title: 'Lessor', inputType: 'dropdown', options: lessor, valueKey: 'id', labelKey: 'name', multiple: true  },
		// lessee_ids: { title: 'Lessee', inputType: 'dropdown', options: lessee, valueKey: 'id', labelKey: 'name', multiple: true },
		// operator_ids: { title: 'Lessee', inputType: 'dropdown', options: lessee, valueKey: 'id', labelKey: 'name', multiple: true },
		// asset: { title: 'Asset', inputType: 'dropdown', options: assetList, valueKey: 'id', labelKey: 'name', multiple: true },
		// lease_status: { title: 'Lease Status', inputType: 'dropdown', options: statusLabel, valueKey: 'id', labelKey: 'Label', multiple: true },
		transaction_types: { title: 'Transaction Type', inputType: 'dropdown', options: transactionTypes, valueKey: 'id', labelKey: 'name' },
		show_only: { title: 'Show Only', inputType: 'dropdown', options: showOnlyOption, valueKey: 'value', labelKey: 'label', multiple: true },
		sections: { title: 'Cashflow Categories', inputType: 'dropdown', options: section, valueKey: 'name', labelKey: 'name' },
		hide_no_activity: { title: 'Hide rows with no activity', inputType: 'checkbox', value: true },
		hide_empty_sections: { title: 'Hide Empty Sections', inputType: 'checkbox', value: true },
	};

	const onApplyFilter = (query) => {
		
		if (query.start_date && query.end_date && moment(query.start_date).isAfter(moment(query.end_date))) {
			enqueueSnackbar('From Date must be before To Date', { variant: 'error' });
			return false;
		}
		const selectedYear = query.year || year;
		if (query.year) {
			setYear(query.year);
		}
		getCashFlowList("", mode, selectedYear, currency, query);
	};

	const handleExport = (fileType) => {
		let query = { file_type: fileType, year: year, scope: 'contract', lease_slug: leaseSlug, currency: currency }
		setExport(true);
		globalGetService(exportCashFlowApi(query)).then((response) => {
			if (checkApiStatus(response)) {
				enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } });
			}
			setExport(false);
		})
	}
	return (
		<>
			<LeasesBasicDetails />
			<Paper className='lease-details-section lease-nav-module-margin lease-module-paper' elevation={0}>
				<LeasesNav />
				{leaseBasicDetails?.status === "Draft" ? (<ModuleNotExcessModal moduleName="Cashflow Statement" />) : leaseBasicDetails && Object.keys(leaseBasicDetails).length > 0 && !leaseBasicDetails?.status ? (<ModuleNotExcessModal leaseNotFound />) :
				<div className='lease-details-content'>
					<Paper className="responsive-paper">
						<Grid container spacing={1} className="responsive-grid" alignItems="end">
							<Grid item size={{ md: 12, xs: 12 }} sx={{ marginBottom:"-8px",}} className='lease-list-link-mt'>
									<BackToLeaseList />
							</Grid>
							<Grid size={'grow'} item xs={12} sx={{ minWidth: 0 }}>
									<Box display="flex" alignItems="center"  gap={1} flexShrink={0}>
										<div style={{ marginTop: "0px", marginLeft: "-5px" }}>
											<FilterComponent filter={filter} filterMenu={cashflowFilterMenu} getResponseBack={(query) => onApplyFilter(query)} />
										</div>
									</Box>
							</Grid>
							<Grid item md={5} xs={12}>
								<ul className='list-inline lease-details-right-items lease-details-btn' style={{ padding: 0 }}>
								  {!(filter?.start_date && filter?.end_date ) ?
									<li className='lease-mobile-button'>
										<Button
											size="small"
											variant="outlined"
											color="primary"
											startIcon={
												<ArrowCircleLeftOutlinedIcon
													sx={{ color: canGoPrev ? '' : 'gray', cursor: canGoPrev ? 'pointer' : 'not-allowed' }}
													onClick={() => {canGoPrev && handleYearChange('prev'); handleItemClicked('Go Previous Year Icon')}}
												/>
											}
											endIcon={
												<ArrowCircleRightOutlinedIcon
													sx={{ color: canGoNext ? '' : 'gray', cursor: canGoNext ? 'pointer' : 'not-allowed' }}
													onClick={() => {canGoNext && handleYearChange('next'); handleItemClicked('Go Next Year Icon')}}
												/>
											}
										>
											{year}
										</Button>
									</li>:null}
									{<li className="list-inline-item lease-mobile-button">
										<PopOverCTA btnText={currencyLabel} onCloseItem={true}>
											<>
												{currencyOptions.map((currency) => (
													<MenuItem key={currency.id} onClick={() => { handleCurrencyChange(currency.code); handleItemClicked(`Clicked on ${currency.code}`); }} >{currency.code}</MenuItem>
												))}
											</>
										</PopOverCTA>
									</li>}
									{cashFlowListing?.mode ? <li className="list-inline-item lease-mobile-button">
										<PopOverCTA btnText={cashFlowListing?.mode}  onCloseItem={true}>
											<>
												<MenuItem onClick={() => { handleModeChange('QUARTERLY'); handleItemClicked('Clicked on Quarterly')}}>QUARTERLY</MenuItem>
												<MenuItem onClick={() => { handleModeChange('YEARLY'); handleItemClicked('Clicked on Yearly')}}>YEARLY</MenuItem>
												<MenuItem onClick={() => { handleModeChange('MONTHLY'); handleItemClicked('Clicked on Monthly')}}>MONTHLY</MenuItem>
											</>
										</PopOverCTA>
									</li> : null }
									{cashFlowListing?.data?.length ? <li className='lease-mobile-button'><ExportFileTypeComp handelExport={handleExport} isLoading={isExport}/></li> : null }
								</ul>
							</Grid>
						</Grid>
					</Paper>
					<Paper className='lease-detail-table' style={{ marginTop: '0px' }} elevation={2} square>
						 {skeletonLoader ? <STableLoader count={6} rowCount={10} /> :
						<div className='cashflow-container' style={{ maxHeight: `${window.innerHeight - (isMobile ? 160 : 227)}px`, overflow: "auto", }}>
							<CashFlowListing cashFlowListing={cashFlowListing} selectedCurrency={currencyLabel} currencySymbol={currencySymbol} onOpenDetails={(payload) => setCashflowDetailsModal({ open: true, ...payload })} handleItemClicked={handleItemClicked} />
						</div> }
						{isLoading ? <PageLoader /> : null}
					</Paper>
				</div>}
			</Paper>
            {cashflowDetailsModal.open && (
                <CashflowDetailsModal open={cashflowDetailsModal.open} onClose={() => setCashflowDetailsModal({ open: false, start_date: null, end_date: null, mode: "monthly" })} start_date={cashflowDetailsModal.start_date} end_date={cashflowDetailsModal.end_date} mode={cashflowDetailsModal.mode} leaseSlug={leaseSlug} currency={currencyLabel} handleItemClicked={handleItemClicked} />
            )}
		</>
	)
}

export default RoleBaseAccess(Cashflow, { application: 'lease_revamp', feature: 'cashflow', operationType: ['R'] });